import React from 'react';
import {Link} from 'react-router-dom';

import logo from '../../images/logo.png';
import User from '../../helpers/user';

export default function Header() {
    return (
        <section id="header">
            <nav className="navbar navbar-expand-lg">
                <div className="container">
                    <Link className="navbar-brand" to="/">
                        <img
                            className="header-logo img-fluid"
                            src={logo}
                            alt="Logo"
                        />
                    </Link>

                    <button
                        className="navbar-toggler"
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"/>
                    </button>

                    <div
                        className="collapse navbar-collapse"
                        id="navbarSupportedContent"
                    >
                        <ul className="navbar-nav ml-auto">
                            {User.isGuest() ? null : (
                                <React.Fragment>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/start/customer/1">
                                            Vevő
                                        </Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link className="nav-link" to="/start/supplier/1">
                                            Szállító
                                        </Link>
                                    </li>

                                    <li className="nav-item">
                                        <button
                                            type="button"
                                            className="nav-link btn btn-link p-0"
                                            onClick={User.logout}
                                        >
                                            Kijelentkezés
                                        </button>
                                    </li>
                                </React.Fragment>
                            )}
                        </ul>
                    </div>
                </div>
            </nav>
        </section>
    );
}


// WEBPACK FOOTER //
// ./src/components/common/Header.js